import {myChannelsApi} from '@/api/my-channels.api.js'
import {addressTypes} from '@/constants/address-types.js'
import {useQuerying} from '@/composables/use-querying.js'
import {useTeams} from '@/composables/use-teams.js'

/**
 * Helper composable for channels querying
 */
export function useChannelsQuerying() {

  //Check if in Teams
  const {isInTeams} = useTeams()

  //Channel querying
  const {
    items: channels,
    loadItems: loadChannels,
    loadMoreItems: loadMoreChannels,
    isLoadingItems: isLoadingChannels,
  } = useQuerying({
    handler: params => myChannelsApi.query(params),
    filter: {
      provider: isInTeams.value ? addressTypes.TEAMS : undefined,
    },
  })

  //Expose interface
  return {
    channels,
    loadChannels,
    loadMoreChannels,
    isLoadingChannels,
  }
}
